import React, {useEffect, useState} from "react";

import VLFModal from "@/components/Modal";
import VLFTextField from "@/components/Input/TextField";
import VLFDatePicker from "@/components/Input/DatePicker";

import {REQUIRED_FIELD} from "@/utils/constants";
import {checkRequiredFields} from "@/utils/functions";

const requiredFields = [
	"date",
	"benchHeight",
	"height",
	"weight",
	"sittingHeight",
];

function HandlePHVInfo(props) {
	const {open, initialData, confirm, close} = props;

	const [formData, setFormData] = useState({});
	const [errors, setErrors] = useState([]);

	useEffect(() => {
		if (initialData) {
			setFormData(initialData);
		}
	}, [initialData]);

	useEffect(() => {
		if (!open) {
			setFormData({});
		}
	}, [open]);

	return (
		<VLFModal
			maxWidth="md"
			open={open}
			title={initialData ? "Modifica informazione" : "Aggiungi informazione"}
			close={close}
			confirm={() => {
				const errors = checkRequiredFields(requiredFields, formData);
				setErrors(errors);

				if (!errors.length) {
					confirm(formData, initialData?.id);
				}
			}}
			content={
				<div className="row">
					<div className="col-xs-12 col-sm-6">
						<VLFDatePicker
							label="Data"
							size="small"
							value={formData.date}
							onChange={(value) => {
								setErrors([]);
								setFormData({...formData, date: value});
							}}
							required
							helperText={errors.indexOf("date") !== -1 ? REQUIRED_FIELD : ""}
							error={errors.indexOf("date") !== -1}
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="benchHeight"
							value={formData.benchHeight || ""}
							onChange={(event) => {
								setErrors([]);
								setFormData({...formData, benchHeight: event.target.value});
							}}
							label="Altezza supporto (cm)"
							placeholder="Altezza supporto (cm)"
							size="small"
							type="number"
							required
							helperText={
								errors.indexOf("benchHeight") !== -1 ? REQUIRED_FIELD : ""
							}
							error={errors.indexOf("benchHeight") !== -1}
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="height"
							value={formData.height || ""}
							onChange={(event) => {
								setErrors([]);
								setFormData({...formData, height: event.target.value});
							}}
							label="Altezza (cm)"
							placeholder="Altezza (cm)"
							size="small"
							type="number"
							required
							helperText={errors.indexOf("height") !== -1 ? REQUIRED_FIELD : ""}
							error={errors.indexOf("height") !== -1}
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="weight"
							value={formData.weight || ""}
							onChange={(event) => {
								setErrors([]);
								setFormData({...formData, weight: event.target.value});
							}}
							label="Peso (kg)"
							placeholder="Peso (kg)"
							size="small"
							type="number"
							required
							helperText={errors.indexOf("weight") !== -1 ? REQUIRED_FIELD : ""}
							error={errors.indexOf("weight") !== -1}
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="sittingHeight"
							value={formData.sittingHeight || ""}
							onChange={(event) => {
								setErrors([]);
								setFormData({...formData, sittingHeight: event.target.value});
							}}
							label="Altezza seduto (cm)"
							placeholder="Altezza seduto (cm)"
							size="small"
							type="number"
							required
							helperText={
								errors.indexOf("sittingHeight") !== -1 ? REQUIRED_FIELD : ""
							}
							error={errors.indexOf("sittingHeight") !== -1}
						/>
					</div>
				</div>
			}
		/>
	);
}

export default HandlePHVInfo;
